
import { makeText, Text$, defaultText, getTextWidthInPixels } from "./Common/DrawHelpers.js";
import { cons, initialize, map, empty, length, tryFindIndex, item, ofArray } from "./fable_modules/fable-library-js.5.13.0/List.js";
import { defaultArg } from "./fable_modules/fable-library-js.5.13.0/Option.js";
import { EditorMsg, Msg, TTMsg } from "./Model/ModelType.js";
import { join, concat, interpolate, printf, toConsole, split } from "./fable_modules/fable-library-js.5.13.0/String.js";
import { item as item_1, equalsWith } from "./fable_modules/fable-library-js.5.13.0/Array.js";
import { createAtom, comparePrimitives, defaultOf } from "./fable_modules/fable-library-js.5.13.0/Util.js";
import { toUInt32, tryParse } from "./fable_modules/fable-library-js.5.13.0/BigInt.js";
import { Record, FSharpRef } from "./fable_modules/fable-library-js.5.13.0/Types.js";
import { hexBignum } from "./Simulator/NumberHelpers.js";
import * as react from "react";
import { input } from "./fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { Option, IInputType } from "./fable_modules/Fulma.3.0.0/Elements/Form/Input.fs.js";
import { dynamicClosablePopup, closablePopup, dialogPopup, preventDefault } from "./DrawBlock/PopupHelpers.js";
import { CSSProp, HTMLAttr, DOMAttr } from "./fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { getTextEventValue } from "./Interface/JSHelpers.js";
import { iterate, singleton, append, delay, toList } from "./fable_modules/fable-library-js.5.13.0/Seq.js";
import { createPolygon } from "./DrawBlock/SymbolView.js";
import { keyValueList } from "./fable_modules/fable-library-js.5.13.0/MapUtil.js";
import { readdir, staticDir } from "./Interface/FilesIO.js";
import { FSharpMap__get_Item, ofList } from "./fable_modules/fable-library-js.5.13.0/Map.js";
import { rangeDouble } from "./fable_modules/fable-library-js.5.13.0/Range.js";
import { getInterval, checkPerformance, getTimeMs } from "./Common/TimeHelpers.js";
import { allRootHierarchiesFromProjectBreadcrumbs, hierarchyBreadcrumbs, Constants_defaultConfig } from "./UI/MiscMenuView.js";
import { record_type, list_type, int32_type } from "./fable_modules/fable-library-js.5.13.0/Reflection.js";
import { PromiseBuilder__For_1565554B, PromiseBuilder__Delay_62FBFDE1, PromiseBuilder__Run_212F1D4B } from "./fable_modules/Fable.Promise.3.1.3/Promise.fs.js";
import { promise } from "./fable_modules/Fable.Promise.3.1.3/PromiseImpl.fs.js";
import { connect, request as request_1 } from "./Interface/SidecarClient.js";
import { error, out } from "./Shared/Log.js";
import { renderEditor, testEditorModel } from "./UI/Editor.js";
import { debugChangedConnections } from "./Simulator/CanvasExtractor.js";
import { DrawModelType_SheetT_Msg } from "./Model/DrawModelType.js";

export const TestFonts_textMeasureWidth = (font) => ((txt) => getTextWidthInPixels(font, txt));

export const TestFonts_testedFonts = ofArray(["arial", "helvetica", "verdana", "tahoma", "600 tahoma", "trebuchet ms", "times", "georgia", "impact"]);

export function TestFonts_nextFontFamily(fontFamily) {
    return item((1 + defaultArg(tryFindIndex((y) => (fontFamily === y), TestFonts_testedFonts), -1)) % length(TestFonts_testedFonts), TestFonts_testedFonts);
}

/**
 * Create the body of a dialog Popup with both text and int.
 */
export function TestFonts_dialogPopupBody(dispatch) {
    dispatch(new Msg(/* TruthTableMsg */ 32, [new TTMsg(/* SetPopupConstraintErrorMsg */ 27, ["times"])]));
    dispatch(new Msg(/* SetPopupDialogText */ 52, ["iiiimmmmyyyy0123456789"]));
    return (model) => {
        let props_14, children_2;
        const dialogData = model.PopupDialogData;
        let fontSpec;
        const matchValue = dialogData.ConstraintErrorMsg;
        fontSpec = ((matchValue != null) ? matchValue : "times");
        const textToTest = defaultArg(dialogData.Text, "iiiimmmmyyyy0123456789");
        let patternInput;
        const matchValue_1 = split(fontSpec, [" "], undefined, 1);
        patternInput = ((!equalsWith((x, y) => (x === y), matchValue_1, defaultOf()) && (matchValue_1.length === 1)) ? ["", item_1(0, matchValue_1)] : ((!equalsWith((x_1, y_1) => (x_1 === y_1), matchValue_1, defaultOf()) && (matchValue_1.length === 2)) ? [item_1(0, matchValue_1), item_1(1, matchValue_1)] : ["", ""]));
        const fontFamily = patternInput[1];
        const font = new Text$("left", `${20}px`, patternInput[0], fontFamily, defaultText.Fill, defaultText.UserSelect, defaultText.DominantBaseline);
        const text = defaultArg(dialogData.Text, "iiiimmmmyyyy0123456789");
        let patternInput_1;
        let outArg = 0n;
        patternInput_1 = [tryParse(text, new FSharpRef(() => outArg, (v) => {
            outArg = v;
        })), outArg];
        const num = patternInput_1[1];
        toUInt32(num) >>> 0;
        toConsole(`BigInteger Parse: num=${num}, success=${patternInput_1[0]} hex= ${hexBignum(num)}`);
        const width = TestFonts_textMeasureWidth(font)(text);
        const height = 20;
        const textEl = makeText(50, 100, text, font);
        const children_4 = [react.createElement("br", {}), react.createElement("br", {}), "Font Family: enter here or click button for known fonts", input(ofArray([new Option(/* Type */ 1, [IInputType.Text$]), new Option(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e) => {
            preventDefault(e);
        }]), new HTMLAttr(/* AutoFocus */ 55, [true]), new HTMLAttr(/* SpellCheck */ 148, [false]), new HTMLAttr(/* Value */ 161, [fontFamily])])]), new Option(/* OnChange */ 13, [(arg_3) => {
            dispatch(new Msg(/* TruthTableMsg */ 32, [new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [getTextEventValue(arg_3)])]));
        }])])), react.createElement("br", {}), react.createElement("br", {}), "Text to show:", input(ofArray([new Option(/* Type */ 1, [IInputType.Text$]), new Option(/* Props */ 15, [ofArray([new DOMAttr(/* OnPaste */ 2, [(e_1) => {
            preventDefault(e_1);
        }]), new HTMLAttr(/* AutoFocus */ 55, [true]), new HTMLAttr(/* SpellCheck */ 148, [false]), new HTMLAttr(/* Value */ 161, [textToTest])])]), new Option(/* OnChange */ 13, [(arg_6) => {
            dispatch(new Msg(/* SetPopupDialogText */ 52, [getTextEventValue(arg_6)]));
        }])])), react.createElement("br", {}), react.createElement("br", {}), (props_14 = [["style", {
            height: 200,
            width: 800,
        }]], (children_2 = toList(delay(() => {
            const pts = `50 100 ${50 + width} 100  ${50 + width} ${100 + height} 50 ${100 + height}`;
            return append(singleton(textEl), delay(() => {
                let children;
                return singleton((children = createPolygon(pts, "red", 0.2), react.createElement("g", {}, ...children)));
            }));
        })), react.createElement("svg", keyValueList(props_14, 1), ...children_2)))];
        return react.createElement("div", {}, ...children_4);
    };
}

export function TestFonts_makeTextPopup(dispatch) {
    dialogPopup("Font test: pink box shows measured width", TestFonts_dialogPopupBody(dispatch), "Change Font", (dd) => {
        dispatch(new Msg(/* TruthTableMsg */ 32, [new TTMsg(/* SetPopupConstraintErrorMsg */ 27, [TestFonts_nextFontFamily(defaultArg(dd.PopupDialogData.ConstraintErrorMsg, ""))])]));
    }, (_arg) => false, empty(), dispatch);
}

/**
 * static assets should theoretically be put under ./static in Issie repo
 * but appear on file system under staticDir() when Issie is run. The exact poistion on disk
 * will vary between production and dev runs, but staticDir()
 * should always work
 */
export function MiscTests_testAssets() {
    const staticD = staticDir();
    toConsole(printf("Static Asset Directory = %s"))(staticD);
    const arg_1 = readdir(staticD);
    toConsole(printf("%A"))(arg_1);
}

export function MiscTests_testMaps() {
    const modMap = ofList(map((n) => [n, ((n * 256) + 1) % 1001], toList(rangeDouble(0, 1, 1000))), {
        Compare: (x, y) => (comparePrimitives(x, y) | 0),
    });
    const start = getTimeMs();
    let x_1 = 1;
    let i = 0;
    while (i < 1000000) {
        x_1 = (FSharpMap__get_Item(modMap, x_1) | 0);
        i = ((i + 1) | 0);
    }
    const interval = getTimeMs() - start;
    toConsole(printf("%d iterations of iterMap took %.1fms"))(1000000)(interval);
}

export function MiscTests_displayPerformance(n, m) {
    checkPerformance(n, m, (label) => {
        console.time(label);
    }, (label_1) => {
        console.timeEnd(label_1);
    });
}

export const Breadcrumbs_config = Constants_defaultConfig;

export function Breadcrumbs_testBreadcrumbs(model, dispatch) {
    closablePopup("Design Hierarchy of current sheet", hierarchyBreadcrumbs(Breadcrumbs_config, dispatch, model), react.createElement("div", {}), empty(), dispatch);
}

export function Breadcrumbs_testAllHierarchiesBreadcrumbs(model, dispatch) {
    closablePopup("Design Hierarchy of all sheets", allRootHierarchiesFromProjectBreadcrumbs(Breadcrumbs_config, dispatch, model), react.createElement("div", {}), empty(), dispatch);
}

export class WebWorker_WorkerPerfTestConfig extends Record {
    constructor(OverheadRuns, OverheadWWs, ConcurrencyTestWWs, NumRuns) {
        super();
        this.OverheadRuns = (OverheadRuns | 0);
        this.OverheadWWs = (OverheadWWs | 0);
        this.ConcurrencyTestWWs = ConcurrencyTestWWs;
        this.NumRuns = (NumRuns | 0);
    }
}

export function WebWorker_WorkerPerfTestConfig_$reflection() {
    return record_type("Playground.WebWorker.WorkerPerfTestConfig", [], WebWorker_WorkerPerfTestConfig, () => [["OverheadRuns", int32_type], ["OverheadWWs", int32_type], ["ConcurrencyTestWWs", list_type(int32_type)], ["NumRuns", int32_type]]);
}

export const WebWorker_Constants_workerTestConfig = new WebWorker_WorkerPerfTestConfig(5, 100, ofArray([2, 4, 6, 8, 10]), 3);

export function WebWorker_geoMean(vals) {
    const x_1 = vals.reduce((x, y) => (x * y));
    const arg1__2 = 1 / vals.length;
    return Math.pow(x_1, arg1__2);
}

export function WebWorker_runTestNTimes(n, testPromise) {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let result = 1;
        return testPromise.then((_arg) => (PromiseBuilder__For_1565554B(promise, toList(rangeDouble(1, 1, n)), (_arg_1) => (testPromise.then((_arg_2) => {
            result = (result * _arg_2);
            return Promise.resolve();
        }))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(result))))));
    }));
    return pr.then((result_1) => {
        const arg1__3 = 1 / n;
        return Math.pow(result_1, arg1__3);
    });
}

export function WebWorker_workerPromise(t) {
    return new Promise((resolve, reject) => {
        const start = getTimeMs();
        const worker = new Worker(new URL("./TestWorker.fs.js", import.meta.url), {type: "module"});
        worker.onmessage = ((msg) => {
            resolve(getInterval(start) / 1000);
        });
        worker.postMessage(t);
    });
}

export function WebWorker_nWorkerPromise(t, n) {
    const pr = initialize(n, (_arg) => WebWorker_workerPromise(t));
    return Promise.all(pr);
}

export function WebWorker_testWorkerConcurrency(n) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (WebWorker_workerPromise("long").then((_arg) => (WebWorker_nWorkerPromise("long", n).then((_arg_1) => {
        const parallelism = n * (_arg / WebWorker_geoMean(_arg_1));
        return Promise.resolve(parallelism);
    }))))));
}

export function WebWorker_testWorkerOverhead(runs) {
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let totalOverhead = 1;
        return PromiseBuilder__For_1565554B(promise, toList(rangeDouble(1, 1, runs)), (_arg) => (WebWorker_workerPromise("short").then((_arg_1) => {
            totalOverhead = (totalOverhead * _arg_1);
            return Promise.resolve();
        }))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(totalOverhead))));
    }));
    return pr.then((total) => {
        const arg1__3 = 1 / runs;
        return Math.pow(total, arg1__3);
    });
}

export function WebWorker_testWorkerCPUOverhead(numWorkers) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => {
        const start = getTimeMs();
        return WebWorker_nWorkerPromise("short", numWorkers).then((_arg) => {
            const timeTaken = getInterval(start) / 1000;
            return Promise.resolve(numWorkers / timeTaken);
        });
    }));
}

export function WebWorker_testWorkers(conf) {
    PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (WebWorker_runTestNTimes(conf.NumRuns, WebWorker_testWorkerOverhead(conf.OverheadRuns)).then((_arg) => {
        toConsole(printf("Average elapsed time overhead: %.2f seconds"))(_arg);
        return WebWorker_runTestNTimes(conf.NumRuns, WebWorker_testWorkerCPUOverhead(conf.OverheadWWs)).then((_arg_1) => {
            toConsole(printf("Can start %.1f workers/second"))(_arg_1);
            return PromiseBuilder__For_1565554B(promise, conf.ConcurrencyTestWWs, (_arg_2) => {
                const i = _arg_2 | 0;
                return WebWorker_runTestNTimes(conf.NumRuns, WebWorker_testWorkerConcurrency(i)).then((_arg_3) => {
                    toConsole(printf("Parallelism with %d workers: %.2f"))(i)(_arg_3);
                    return Promise.resolve();
                });
            });
        });
    }))));
}

/**
 * What the latency test sends. Sizes are payload bytes; each size is measured in all three
 * directions (echo both ways, upload, download), warmed up untimed first.
 */
export class Sidecar_SidecarLatencyTestConfig extends Record {
    constructor(PayloadSizes, Warmup, Runs, BigRuns, BigThreshold) {
        super();
        this.PayloadSizes = PayloadSizes;
        this.Warmup = (Warmup | 0);
        this.Runs = (Runs | 0);
        this.BigRuns = (BigRuns | 0);
        this.BigThreshold = (BigThreshold | 0);
    }
}

export function Sidecar_SidecarLatencyTestConfig_$reflection() {
    return record_type("Playground.Sidecar.SidecarLatencyTestConfig", [], Sidecar_SidecarLatencyTestConfig, () => [["PayloadSizes", list_type(int32_type)], ["Warmup", int32_type], ["Runs", int32_type], ["BigRuns", int32_type], ["BigThreshold", int32_type]]);
}

export const Sidecar_Constants_latencyTestConfig = new Sidecar_SidecarLatencyTestConfig(ofArray([0, 1024, 65536, 1048576, 16777216]), 2, 10, 3, 1048576);

function Sidecar_runSeries(warmup, runs, cmd, payload) {
    return PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (PromiseBuilder__For_1565554B(promise, toList(rangeDouble(1, 1, warmup)), (_arg) => (request_1(cmd, payload).then((_arg_1) => {
        return Promise.resolve();
    }))).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => {
        let total = 0;
        return PromiseBuilder__For_1565554B(promise, toList(rangeDouble(1, 1, runs)), (_arg_2) => {
            const start = getTimeMs();
            return request_1(cmd, payload).then((_arg_3) => {
                total = (total + getInterval(start));
                return Promise.resolve();
            });
        }).then(() => PromiseBuilder__Delay_62FBFDE1(promise, () => (Promise.resolve(total / runs))));
    })))));
}

function Sidecar_throughput(bytes, ms) {
    if (ms <= 0) {
        return 0;
    }
    else {
        return (bytes / 1000000) / (ms / 1000);
    }
}

/**
 * Development > Play > Test Sidecar Latency. Output goes to Log.out because it is what was
 * asked for; errors (sidecar not up yet, connection dropped) land on Log.error.
 */
export function Sidecar_testLatency(conf) {
    let pr;
    (pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (connect().then(() => {
        out("sidecar latency: mean round trip, renderer <-> dotnet sidecar over a loopback WebSocket");
        return PromiseBuilder__For_1565554B(promise, conf.PayloadSizes, (_arg_1) => {
            const size = _arg_1 | 0;
            const runs = ((size >= conf.BigThreshold) ? conf.BigRuns : conf.Runs) | 0;
            const sized = () => (new Uint8Array(size));
            return Sidecar_runSeries(conf.Warmup, runs, 1, sized()).then((_arg_2) => {
                const echoMs = _arg_2;
                return Sidecar_runSeries(conf.Warmup, runs, 2, sized()).then((_arg_3) => {
                    let request;
                    const upMs = _arg_3;
                    return Sidecar_runSeries(conf.Warmup, runs, 3, (request = (new Uint8Array(4)), (new DataView(request.buffer, request.byteOffset).setUint32(0, size, true), request))).then((_arg_4) => {
                        const downMs = _arg_4;
                        const mbs = Sidecar_throughput;
                        out((((`${interpolate("%9d%P()", [size])}B x${interpolate("%2d%P()", [runs])}:  `) + (`echo ${interpolate("%8.3f%P()", [echoMs])}ms (${interpolate("%.1f%P()", [mbs(2 * size, echoMs)])}MB/s)  `)) + (`up ${interpolate("%8.3f%P()", [upMs])}ms (${interpolate("%.1f%P()", [mbs(size, upMs)])}MB/s)  `)) + (`down ${interpolate("%8.3f%P()", [downMs])}ms (${interpolate("%.1f%P()", [mbs(size, downMs)])}MB/s)`));
                        return Promise.resolve();
                    });
                });
            });
        });
    })))), pr.catch((e) => {
        error(concat("sidecar latency test: ", e.message));
    }));
}

export function Misc_makeEditorPopup(dispatch) {
    dispatch(new Msg(/* CodeEditorMsg */ 127, [new EditorMsg(/* UpdateCodeEditorState */ 3, [(_arg) => testEditorModel])]));
    dynamicClosablePopup("Editor Demo", (model) => {
        const matchValue = model.CodeEditorState;
        if (matchValue == null) {
            return react.createElement("div", {});
        }
        else {
            return renderEditor(matchValue, dispatch);
        }
    }, (_arg_1) => react.createElement("div", {}), ofArray([new CSSProp(/* Height */ 189, ["auto"]), new CSSProp(/* Width */ 395, ["auto"])]), dispatch);
}

export function Misc_highLightChangedConnections(dispatch) {
    dispatch(new Msg(/* Sheet */ 3, [new DrawModelType_SheetT_Msg(/* SelectWires */ 31, [debugChangedConnections()])]));
    debugChangedConnections(empty());
}

export function Memory_printProcessMemory() {
    const memInfo = window.issieBridge.diagnostics.processMemory();
    const pr = PromiseBuilder__Run_212F1D4B(promise, PromiseBuilder__Delay_62FBFDE1(promise, () => (memInfo)));
    void (pr.then((info) => {
        toConsole(`mem info: private= ${~~(info.private / 1000)}, resident=${info.resident}`);
    }));
}

export function Memory_printMemory() {
    const toMB = (f) => (`${interpolate("%10.1f%P()", [f / 1000000])}`);
    const printDetails = (tupledArg) => {
        const d = tupledArg[1];
        if (d != null) {
            const d_1 = d;
            return `${interpolate("%20s%P()", [tupledArg[0]])} ${interpolate("%10s%P()", [toMB(d_1.count)])} ${interpolate("%10s%P()", [toMB(d_1.liveSize)])} ${interpolate("%10s%P()", [toMB(d_1.size)])}`;
        }
        else {
            return `${interpolate("%20s%P()", ["object"])} ${interpolate("%10s%P()", ["count"])} ${interpolate("%10s%P()", ["livesize"])} ${interpolate("%10s%P()", ["size"])}`;
        }
    };
    const usage = window.issieBridge.diagnostics.resourceUsage();
    const details = map((tupledArg_1) => [tupledArg_1[0], tupledArg_1[1]], ofArray([["images", usage.images], ["other", usage.other], ["cssStyleSheets", usage.cssStyleSheets], ["xslstylesheets", usage.xslStyleSheets], ["fonts", usage.fonts], ["scripts", usage.scripts]]));
    const arg = join("\n", cons(printDetails(["", undefined]), map(printDetails, details)));
    toConsole(printf("%s"))(arg);
    window.issieBridge.diagnostics.clearCache();
}

/**
 * The renderer has no ipcRenderer of its own any more, so what this counts is what the preload
 * holds on its behalf - which is what leaks if anything does, and what this was always after.
 */
export function Memory_printListeners() {
    const counts = window.issieBridge.diagnostics.ipcListenerCounts();
    iterate((name) => {
        toConsole(`${name} -> ${counts[name]}`);
    }, Object.keys(counts));
}

export let Memory_modelCopy = createAtom(undefined);

